var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowsDown = function SvgArrowsDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "arrows-down_svg__icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M798.336 495.616a57.216 57.216 0 0 0 80.256 0 56.576 56.576 0 0 0 0-80.64l-326.144-326.4a56.32 56.32 0 0 0-81.28 0L144.64 415.104a57.216 57.216 0 0 0 0 80.64 57.728 57.728 0 0 0 80.64 0l285.952-286.72 287.104 286.72z"
  })));
};

export default SvgArrowsDown;